import {
  clearLastMentorsSearchAndFilters,
  getMentorsQuestionAnswers,
  searchMentors,
  setSearchMentorsResultTotalCount,
} from 'redux/actions/mentoring-program-participant-driven';
import { initialRootState } from '.';
import { replaceArrays } from 'shared/lodash-utils';
import { createReducer } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { mergeWith } from 'lodash';
import { MentoringProgramParticipantDrivenMentorsSchema, MentoringProgramParticipantDrivenMentorFiltersSchema } from 'redux/schemas/api/mentoring-program-participant-driven';

export default createReducer(initialRootState, (builder) => {
  builder
    .addCase(searchMentors.pending, (state, action) => {
      if (state.app.mentoringProgram.participantDriven.findMentorSource) {
        state.app.mentoringProgram.participantDriven.findMentorSource.isLoading = true;
      }
    })
    .addCase(searchMentors.fulfilled, (state, action) => {
      const normalized = normalize(
        action.payload,
        MentoringProgramParticipantDrivenMentorsSchema
      );
      const { meta: { arg } } = action;
      const { searchTerm, filters, page } = arg || {};
      const currentKeys = state.app.mentoringProgram.participantDriven.findMentorSource?.resultKeys || [];
      const newKeys = normalized.result.filter(id => !currentKeys.includes(id));
      state.app.mentoringProgram.participantDriven.findMentorSource = {
        searchTerm: searchTerm || '',
        filters: Object.fromEntries(filters.map(f => [f.question_id, f.answers])),
        resultKeys: page === 1 ? normalized.result : [
          ...currentKeys,
          ...newKeys,
        ],
        lastPage: page,
        isLoading: false,
      };
      mergeWith(state.models, normalized.entities, replaceArrays);
    })
    .addCase(searchMentors.rejected, (state) => {
      if (state.app.mentoringProgram.participantDriven.findMentorSource) {
        state.app.mentoringProgram.participantDriven.findMentorSource.isLoading = false;
      }
    })
    .addCase(getMentorsQuestionAnswers.fulfilled, (state, action) => {
      const { payload: mentorFilters } = action;
      const normalized = normalize(
        mentorFilters,
        MentoringProgramParticipantDrivenMentorFiltersSchema
      );
      state.app.mentoringProgram.participantDriven.mentorsFilters = normalized.entities.mentorsFilters || {};
    })
    .addCase(getMentorsQuestionAnswers.rejected, (state, action) => {
      // Clear filters
      state.app.mentoringProgram.participantDriven.mentorsFilters = {};
    })
    .addCase(setSearchMentorsResultTotalCount, (state, action) => {
      const { totalCount } = action.payload;
      state.app.mentoringProgram.participantDriven.resultsCount = totalCount;
    })
    .addCase(clearLastMentorsSearchAndFilters, (state) => {
      state.app.mentoringProgram.participantDriven.findMentorSource = {
        searchTerm: '',
        filters: {},
        resultKeys: [],
        lastPage: 0,
        isLoading: false,
      };
    });
});
